import { useState } from 'react';

export const useSliderIndex = (count: number, initial = 0) => {
  const [index, setIndex] = useState(initial);

  // Les changements d'index sont cycliques
  const next = () => setIndex(v => (v + count + 1) % count);
  const prev = () => setIndex(v => (v + count - 1) % count);
  const goto = (idx: number) => setIndex((idx + count) % count);

  return { index, goto, next, prev };
};
